'use client'
import { cn } from '../../helpers/utils.js'
import type { Img } from '../../types/props.js'
import { withLayout } from '../../shared/Styles.js'
import { Picture, Text } from '../../components/index.js'

type AplusItem = {
  img: Img
  mobileImg: Img
  title: string
  desc: string
  theme: 'light' | 'dark'
}

interface AplusDescType extends React.HTMLAttributes<HTMLDivElement> {
  data: {
    title: string
    img: Img
    mobileImg: Img
    list: AplusItem[]
  }
}

const AplusDesc = ({ data, className, ...rest }: AplusDescType) => {
  const { title, img, mobileImg, list } = data

  return (
    <>
      <div {...rest} className={cn('w-full', className)}>
        <div className="desktop:items-center desktop:justify-between desktop:flex-row flex w-full flex-col">
          <div className=" desktop:w-[600px] lg-desktop:w-[800px]">
            {title && (
              <Text
                html={title}
                className="desktop:text-[16px] lg-desktop:text-[18px] text-[14px] font-bold leading-[1.2]"
              />
            )}
          </div>
          <div>
            {img?.url && (
              <Picture
                className="desktop:block hidden w-[464px] rounded-2xl"
                imgClassName=""
                source={data?.img?.url}
                alt={data?.img?.alt || ''}
              />
            )}
            {mobileImg?.url && (
              <Picture
                className="desktop:hidden block w-[224px] rounded-2xl"
                imgClassName=""
                source={data?.mobileImg?.url}
                alt={data?.mobileImg?.alt || ''}
              />
            )}
          </div>
        </div>
        <div className="tablet:grid-cols-2 desktop:grid-cols-3 mt-[24px] grid grid-cols-1 gap-[16px]">
          {list.map((item, ind) => (
            <div key={ind} className="relative">
              <Picture className=" rounded-2xl" imgClassName="" source={item?.img?.url} alt={item?.img?.alt || ''} />
              <div
                className={cn(
                  'text-info-primary desktop:bottom-[24px] desktop:left-[24px] lg-desktop:bottom-[32px] lg-desktop:left-[32px] absolute bottom-[16px] left-[16px] flex flex-col',
                  {
                    'aiui-dark': item.theme === 'dark',
                  }
                )}
              >
                <Text html={item?.title} className=" lg-desktop:text-[24px] text-[20px] font-bold leading-[1.2]" />
                <Text html={item?.desc} className=" lg-desktop:text-[16px] text-[14px] font-bold leading-[1.4]" />
              </div>
            </div>
          ))}
        </div>
      </div>
    </>
  )
}

export default withLayout(AplusDesc)
